"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Modal = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/Modal"));
var _grid = require("@rebass/grid");
var _dynamic = _interopRequireDefault(require("next/dynamic"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactSpring = require("react-spring");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _trip = require("../utils/trip");
var _Spinner = _interopRequireDefault(require("./designsystem/Spinner"));
var _TitleWrapper = _interopRequireDefault(require("./designsystem/TitleWrapper"));
const _excluded = ["onClose", "name", "open", "id", "booking"];
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Planner = (0, _dynamic.default)(() => Promise.resolve().then(() => _interopRequireWildcard(require('./TripPlanner'))), {
  ssr: false,
  loading: () => __jsx(_Spinner.default, null),
  loadableGenerated: {
    webpack: () => [require.resolveWeak('./TripPlanner')]
  }
});
const TripPlannerModal = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
      onClose,
      name,
      open,
      id,
      booking
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return __jsx(StyledModal, {
    config: _objectSpread(_objectSpread({}, _reactSpring.config.gentle), {}, {
      duration: 200
    }),
    variant: "full",
    onClose: onClose,
    open: open
  }, __jsx(Content, null, __jsx(Planner, (0, _extends2.default)({
    headerChildren: name && __jsx(_TitleWrapper.default, {
      title: __jsx(_react.default.Fragment, null, (0, _trip.validBooking)(booking) && __jsx(_react.default.Fragment, null, __jsx(_reactIntl.FormattedMessage, {
        id: "bdCpFx",
        defaultMessage: [{
          "type": 2,
          "style": null,
          "value": "duration"
        }, {
          "type": 0,
          "value": " "
        }, {
          "type": 6,
          "pluralType": "cardinal",
          "value": "duration",
          "offset": 0,
          "options": {
            "one": {
              "value": [{
                "type": 0,
                "value": "nacht"
              }]
            },
            "other": {
              "value": [{
                "type": 0,
                "value": "nachten"
              }]
            }
          }
        }],
        values: {
          duration: (0, _trip.getTripDuration)(booking.arrivalDate, booking.departureDate)
        }
      }), ' — '), name)
    }),
    booking: booking
  }, props))));
}, (prev, next) => {
  if (!prev.open && !next.open) {
    return true;
  }
  return Object.keys(next).every(key => Object.is(prev[key], next[key]));
});
var _default = exports.default = TripPlannerModal;
const Content = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "TripPlannerModal__Content",
  componentId: "jwpubr-0"
})(["padding:0rem 0.1rem;overflow:hidden;@media screen and (min-width:", "){padding-top:4rem;overflow:visible;padding-bottom:10rem;}width:100%;max-width:140.8rem;margin:auto;@media screen and (max-width:", "px){height:100%;}"], ({
  theme
}) => theme.mediaQueries.s, ({
  theme
}) => theme.mediaQueriesValues.s - 1);
const StyledModal = (0, _styledComponents.default)(_Modal.default).withConfig({
  displayName: "TripPlannerModal__StyledModal",
  componentId: "jwpubr-1"
})(["&& > [data-reach-dialog-overlay]{overflow:unset;}&& > [data-reach-dialog-content]{padding:0;}@media screen and (max-width:", "px){padding:0;}"], ({
  theme
}) => theme.mediaQueriesValues.s - 1);